export amenity from './amenity/triggers';
export area from './area/triggers';
export blockedDateRange from './blocked-date-range/triggers';
export channel from './channel/triggers';
export synchronisation from './synchronisation/triggers';
export owner from './owner/triggers';
//export locality from './locality/triggers';
export property from './property/triggers';
export propertyGroup from './propertyGroup/triggers';
export zone from './zone/triggers';



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/triggers.js